import { inject, Injectable } from '@angular/core';
import { GlobalLoadingComponent } from '@shared/components/global-loading/global-loading.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

@Injectable({ providedIn: 'root' })
export class LoadingService {
	private readonly dialogService = inject(DialogService);
	private ref: DynamicDialogRef<GlobalLoadingComponent> | null = null;

	show() {
		this.ref = this.dialogService.open(GlobalLoadingComponent, {
			closable: false,
			draggable: false,
			resizable: false,
			baseZIndex: 10000,
			width: '100vw',
			height: '100vh',
			focusOnShow: false,
		});
	}

	hide() {
		if (this.ref) {
			this.ref.close();
			this.ref = null;
		}
	}
}
